// extracted by mini-css-extract-plugin
module.exports = {"nestedMenuItem":"NestedMenuItem_nestedMenuItem__2IrSb","menuItemBody":"NestedMenuItem_menuItemBody__3qIws"};